var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.154,
    height: 80.093,
    viewBox: "0 0 83.154 80.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-1095.712 -426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-1949.953-3429.907a39.6,39.6,0,0,1-15.557-3.157,40.077,40.077,0,0,1-12.733-8.6,40.079,40.079,0,0,1-8.6-12.732,39.6,39.6,0,0,1-3.157-15.557,39.6,39.6,0,0,1,3.157-15.557,40.078,40.078,0,0,1,8.6-12.733,40.079,40.079,0,0,1,12.733-8.6,39.6,39.6,0,0,1,15.557-3.157,39.6,39.6,0,0,1,15.557,3.157,40.076,40.076,0,0,1,12.733,8.6,40.075,40.075,0,0,1,8.6,12.733,39.6,39.6,0,0,1,3.157,15.557q0,.168,0,.337a7.145,7.145,0,0,0-5.509-3.132,5.412,5.412,0,0,0-.564-.02,7.134,7.134,0,0,0-4.794,1.823l-1.453,1.179q0-.094,0-.188a27.756,27.756,0,0,0-27.724-27.725,27.756,27.756,0,0,0-27.725,27.725,27.756,27.756,0,0,0,27.725,27.724,26.433,26.433,0,0,0,3.081-.168v12.37C-1948.006-3429.946-1949.014-3429.907-1949.953-3429.907Zm0-36.966h-12.322a3.063,3.063,0,0,1-2.181-.9,3.063,3.063,0,0,1-.9-2.181,3.063,3.063,0,0,1,.9-2.181,3.063,3.063,0,0,1,2.181-.9h9.241v-15.4a3.063,3.063,0,0,1,.9-2.181,3.063,3.063,0,0,1,2.181-.9,3.063,3.063,0,0,1,2.181.9,3.063,3.063,0,0,1,.9,2.181v18.482a3.063,3.063,0,0,1-.9,2.181A3.063,3.063,0,0,1-1949.953-3466.873Z",
    transform: "translate(3085.712 3936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "document-edit-svgrepo-com",
    d: "M26.95.1a8.712,8.712,0,0,0-3.97,2.463L6.531,19.634c-.86.86-.9.658-1.935,3.286L1,33.318l10.848-3.424c2.956-.707,3.461-1.482,3.461-1.482L31.757,11.338C36.5,4.984,32.518-.548,27.908-.049A3.57,3.57,0,0,0,26.95.1Z",
    transform: "translate(1140.663 473.238) rotate(-8)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAppointmentIcon);
export default __webpack_public_path__ + "static/media/editAppointmentIcon.71cde7260937a5bf337ed0ee0eb5e80a.svg";
export { ForwardRef as ReactComponent };